import axios from 'axios'
import store from "@/store";
import router from '@/router'

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    timeout: 20000,
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
    'Access-Control-Allow-Origin': '*'
    //   withCredentials: true,
})

axiosInstance.defaults.headers['Content-Type'] = 'application/vnd.api+json'
axiosInstance.defaults.headers.Accept = 'application/vnd.api+json'

// request interceptor
axiosInstance.interceptors.request.use(config => {
    const token = store.getters.getToken

    // alert(token);
    // //localStorage.getItem("access_token");
    if (token) {
        config.headers.authorization = 'Bearer ' + token
    // config.headers.token = token;
    // config.headers["Authorization"] = token;
    } else {
    // config.headers.Authorization = token;
    }

    return config
}, err => {
    return Promise.reject(err)
})

// Códigos que devuelve JwtMiddleware cuando el problema es la sesión en sí.
const SESSION_ERRORS = ['token_not_found', 'token_invalid', 'token_expired', 'user_disabled']

/**
 * Un 403 no significa "tu sesión ha caducado".
 *
 * La API responde 403 en tres situaciones muy distintas: sesión no válida
 * (JwtMiddleware), permisos insuficientes (las policies, isAdminMiddleware) y
 * peticiones cortadas por el WAF del Application Gateway antes de llegar a Laravel.
 * Cerrar la sesión ante los tres significaba que, al guardar unos términos que el
 * WAF rechazaba, al administrador se le echaba al login y perdía todo lo escrito.
 * Ahora solo se cierra cuando el fallo es realmente de sesión.
 */
function isSessionFailure(response) {
    if (response.status === 401) {
        return true
    }

    if (response.status !== 403) {
        return false
    }

    const data = response.data

    // El 403 del WAF llega como página HTML, no como JSON: nunca es fallo de sesión.
    if (!data || typeof data !== 'object') {
        return false
    }

    if (SESSION_ERRORS.includes(data.error)) {
        return true
    }

    // Compatibilidad con backends anteriores a que se añadiera `error`.
    return typeof data.status === 'string' && /token|deshabilitado/i.test(data.status)
}

// response interceptor
axiosInstance.interceptors.response.use(response => {
    return response
}, err => {
    const response = err?.response

    // Sin respuesta (red caída, timeout de los 20 s, petición cancelada) no hay
    // nada que interpretar. Antes se leía err.response.status a ciegas y el
    // TypeError resultante sustituía al error real que esperaba el formulario.
    if (!response) {
        return Promise.reject(err)
    }

    if (isSessionFailure(response)) {
        store.dispatch('signOut');

        router.push({ path: '/app/sessions/sign-in-two' });
    } else if (response.status === 423) {
        store.dispatch('snackbar/error', "Esta operación no está permitida actualmente");
    }

    return Promise.reject(err)
})

export default axiosInstance
